import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PageService } from '../../_services/index';
import { CustomPage } from '../../_models/index';

@Component({
    selector: 'app-portal',
    templateUrl: './portal.component.html',
    styleUrls: ['./portal.component.scss'],
    standalone: false
})
export class PortalComponent implements OnInit {
    selectedPage: CustomPage;
    constructor (
        private title: Title,
        private pageService: PageService) { }

    ngOnInit() {
        this.title.setTitle('Solent Wholesale | B2B Portal');
        this.pageService.getCustomPage('care').subscribe(page => {
            this.selectedPage = page;
        });
    }

}
